<template>
    <div class="dashboard-container">
        <component :is="currentRole"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import adminDashboard from './admin/index_bak'
    import editorDashboard from './editor'

    export default {
        name: 'dashboard',
        components: {adminDashboard, editorDashboard},
        data() {
            return {
                currentRole: 'adminDashboard'
            }
        },
        computed: {
            ...mapGetters([
                'roles'
            ])
        },
        created() {
            // if (!this.roles.includes('admin')) {
            //     this.currentRole = 'editorDashboard'
            // }
        }
    }
</script>
